import { call, put } from "redux-saga/effects";
import { resolvePromiseAction, rejectPromiseAction } from "@adobe/redux-saga-promise";

import Api from "common/api";
import constants from "./constants";

export default {
  /**
   * call business account api
   * @param {*} data
   */
  getBusinessAccount: function* (data) {
    const __name = constants.GET_BUSINESS_ACCOUNT;
    try {
      const res = yield call(Api.getBusinessAccount, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
};
